<template>
  <TitledNumericalInputField
    inputLabel="Fouling"
    iconName="mdi-grass"
    :value="+efficiency.toFixed(2)"
    :rules="[(value) => value >= 0 || 'Value must be positive']"
    :onChange="handleInputChange"
  />
</template>


<script>
import TitledNumericalInputField from "../../../../../k_diagram/components/TitledNumericalInputField.vue";
import { mapState } from "vuex";
export default {
  name: "SetFoulingComponent",
  components: {
    TitledNumericalInputField,
  },
  computed: {
    ...mapState("weatherRouting/formModule", ["efficiency"]),
  },
  methods: {
    handleInputChange(value) {
      this.$store.commit("weatherRouting/formModule/SET_EFFICIENCY", value, {
        root: true,
      });
    },
  },
};
</script>
